export const USDC_SPOT_MARKET_INDEX = 0;

export const DEFAULT_MAX_MARKET_LEVERAGE = 10;
